import { render, staticRenderFns } from "./DateOfBirthSelectInput.vue?vue&type=template&id=e8f13814"
import script from "./DateOfBirthSelectInput.vue?vue&type=script&lang=js"
export * from "./DateOfBirthSelectInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports